import React from 'react';
import PropTypes from 'prop-types';
import ReactToolTip from 'react-tooltip';

import shoppingError from '../../../assets/images/CBX_Warning.png';
import see from '../../../assets/images/CBX_ErrorAlert.png';

/**
* SpotError component
* @property {Object} props - component props
* @returns {JSX}
*/
const SpotError = ({ foundSpot = true, locale, successful }) => (
  foundSpot && (
  <div>
    <img
      alt=""
      style={{ cursor: 'pointer', paddingLeft: '10px' }}
      width={window.innerWidth < 768 ? '35' : '55'}
      height="auto"
      src={shoppingError}
      data-tip
      data-for="warningToolTip"
    />

    <ReactToolTip id="warningToolTip" place="right" type="dark" effect="solid" >
      {`${locale === 'es' ? 'Espacio de estacionamiento no disponible' : 'Parking spot not available'}`}
    </ReactToolTip>

  </div>),

  successful === 0 && (
    <div>
      <img
        alt=""
        style={{ cursor: 'pointer', paddingLeft: '10px' }}
        width={window.innerWidth < 768 ? '80' : '85'}
        height="auto"
        src={see}
        data-tip
        data-for="failedItemToolTip"
      />
  
      <ReactToolTip id="failedItemToolTip" place="right" type="dark" effect="solid" >
        {`${locale === 'es' ? 'Espacios de estacionamiento no disponibles, vuelva a intentarlo.' : 'Parking spots not available, try again.'}`}
      </ReactToolTip>
  
    </div>)
);

SpotError.propTypes = {
  locale: PropTypes.string,
  foundSpot: PropTypes.bool,
  successful: PropTypes.bool
};

export default SpotError;